var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHowItWorksImage3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 556.755,
    height: 441.202,
    viewBox: "0 0 556.755 441.202",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "shutterstock_1497621995_Image_minify",
    x: 0,
    y: 0,
    width: 556.755,
    height: 441.202,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#333",
    floodOpacity: 0.251
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_394",
    "data-name": "Group 394",
    transform: "translate(-6021 1666.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_277",
    "data-name": "Group 277",
    transform: "translate(6058 -1634)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -37, -32.5)",
    filter: "url(#shutterstock_1497621995_Image_minify)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "shutterstock_1497621995_Image_minify-2",
    "data-name": "shutterstock_1497621995_Image_minify",
    width: 481.755,
    height: 366.202,
    rx: 16,
    transform: "translate(37.5 32.5)",
    fill: "#fff",
    opacity: 0
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_276",
    "data-name": "Group 276",
    transform: "translate(38.378 72.507)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_284",
    "data-name": "Group 284",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Your_stylist_arrives_and_gets_the_job_done._Pay_securely_and_leave_a_review.",
    "data-name": "Your stylist arrives and gets the job done. Pay securely and leave a review.",
    transform: "translate(13.499 229.084)",
    fill: "#4b4d4e",
    fontSize: 18,
    fontFamily: "YuGothic-Regular, Yu Gothic",
    opacity: 0.62
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Your stylist arrives and gets the job done. Pay"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 29
  }, "securely and leave a review.")), /*#__PURE__*/React.createElement("g", {
    id: "Group_283",
    "data-name": "Group 283",
    transform: "translate(93.499 173.353)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Get_it_done_",
    "data-name": "Get it done!",
    transform: "translate(29.062 25.778)",
    fill: "#4b4d4e",
    fontSize: 34,
    fontFamily: "YuGothic-Bold, Yu Gothic",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Get it done!")), /*#__PURE__*/React.createElement("g", {
    id: "Group_282",
    "data-name": "Group 282",
    transform: "translate(-5 -1.252)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_86",
    "data-name": "Ellipse 86",
    cx: 14.531,
    cy: 14.531,
    r: 14.531,
    transform: "translate(0 0.03)",
    fill: "#2597f6"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_3",
    "data-name": 3,
    transform: "translate(9 21.029)",
    fill: "#fff",
    fontSize: 18,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "3")))), /*#__PURE__*/React.createElement("g", {
    id: "undraw_completing_re_i7ap",
    transform: "translate(107.536 -63.482)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_419",
    "data-name": "Path 419",
    d: "M460.824,490.821a20.968,20.968,0,0,0-15.042-6.139h-.223a21.478,21.478,0,0,1-10.827-2.924l-.342-.2.275-.284a20.934,20.934,0,0,0,3.692-5.227,6.33,6.33,0,0,1-5.109,1.65,6.482,6.482,0,0,1-4.759-3.048c-2.019-3.275-4.425-7.923-4.425-11.464a21.544,21.544,0,0,1,7.029-15.9,13.415,13.415,0,0,0,4.432-10v-.268a30.439,30.439,0,0,1,.9-7.367l.06-.239.25.009a20.569,20.569,0,0,0,4.81-.4,16.237,16.237,0,0,1-4.313-1.147l-.269-.109.091-.276c6.3-3.9,20.511-1.88,28.761-20.756,6.69-15.306,30.294,13.587,30.294,30.288,0,1.7-1.686,3.956-.424,5.082,13.648,12.176,4.231,19.995,1.262,27.862-.7,1.867.823,3.916.823,5.935,0,.343-.009.7-.026,1.051l-.026.546-.455-.3a15.078,15.078,0,0,1-2.489-2.042,13.135,13.135,0,0,1-.417,11.34,20.083,20.083,0,0,1-4.113,5.744,21.474,21.474,0,0,1-29.424-1.414Z",
    transform: "translate(-387.209 -304.867)",
    fill: "#08c4bb",
    opacity: 0.44
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_420",
    "data-name": "Path 420",
    d: "M566.691,632.25a.387.387,0,0,0,.382-.332,129.442,129.442,0,0,0,.18-27.136c-1.334-14.24-5.619-34.751-18.454-51.6a.387.387,0,1,0-.615.469c12.725,16.7,16.975,37.06,18.3,51.2a128.545,128.545,0,0,1-.176,26.955.387.387,0,0,0,.383.441Z",
    transform: "translate(-470.227 -405.683)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_421",
    "data-name": "Path 421",
    d: "M495.084,605.869a.387.387,0,0,0,.228-.7,53.278,53.278,0,0,0-11.762-5.987c-6.489-2.376-16.357-4.53-26.516-1.3a.387.387,0,1,0,.234.737c9.951-3.167,19.64-1.049,26.016,1.286a52.4,52.4,0,0,1,11.573,5.887A.385.385,0,0,0,495.084,605.869Z",
    transform: "translate(-409.094 -434.605)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_422",
    "data-name": "Path 422",
    d: "M602.538,491.261a.387.387,0,0,0-.681-.277,53.28,53.28,0,0,0-6.819,11.3c-2.837,6.3-5.7,15.989-3.2,26.354a.387.387,0,0,0,.752-.181c-2.442-10.153.369-19.664,3.156-25.856a52.4,52.4,0,0,1,6.705-11.119.385.385,0,0,0,.09-.221Z",
    transform: "translate(-498.856 -364.062)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_423",
    "data-name": "Path 423",
    d: "M773.342,725H742.569l-.132-.24c-.393-.714-.773-1.47-1.128-2.247-3.17-6.786-4.51-14.548-5.692-21.4l-.89-5.161a3.187,3.187,0,0,1,5.017-3.118q7.015,5.1,14.035,10.2c1.772,1.289,3.8,2.782,5.734,4.394.187-.908.382-1.819.578-2.717a3.189,3.189,0,0,1,5.824-1.007l3.6,5.785c2.626,4.224,4.944,8.387,4.471,12.877a.7.7,0,0,1-.012.163,10.15,10.15,0,0,1-.523,2.161Z",
    transform: "translate(-595.098 -498.845)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424",
    "data-name": "Path 424",
    d: "M781.6,375.55l-5.939-21.982a3.675,3.675,0,0,0-4.458-2.591h0a3.675,3.675,0,0,0-2.594,4.661l6.869,22.645,3.594,13.936a3.207,3.207,0,1,0,4.112.183Z",
    transform: "translate(-617.694 -270.373)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_425",
    "data-name": "Path 425",
    d: "M614.242,369.775l18.045-13.887a3.675,3.675,0,0,0,.691-5.11h0a3.675,3.675,0,0,0-5.3-.616l-18.3,15-11.505,8.646a3.207,3.207,0,1,0,1.4,3.87Z",
    transform: "translate(-500.31 -269.333)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_426",
    "data-name": "Path 426",
    d: "M699.983,418.854l-.8,17.764,24.975-5.428c-2.126-7.138-3.571-8.356-1.974-13.323Z",
    transform: "translate(-571.344 -315.219)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_427",
    "data-name": "Path 427",
    d: "M707.407,322.378h-8.322l-3.574,6.115-1.7-.094a6.135,6.135,0,0,0-6.473,6.126h0l2.1,3.252s-3.752,6.539,1.653,9.757c0,0-.964,6.061,0,6s3.185-1.3.964-.065-2.055,1.4-1.768,1.686l.287.287,23.349,3.921s.683-4.526.757-5.334-.42,1.166.074-.807,1.234-1.234.493-1.974,4.8-9.91,2.521-13.467l3.647-3.557h0c0-3.412-5.48-6.178-8.892-6.178h-.437Z",
    transform: "translate(-563.411 -251.31)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_428",
    "data-name": "Path 428",
    d: "M364.793,636.887h-3.368l-1.6-12.992h4.971Z",
    transform: "translate(-240.847 -417.577)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_429",
    "data-name": "Path 429",
    d: "M656.641,771.578a1.433,1.433,0,0,0,1.424,1.427h6.341l.2-.407.9-1.851.347,1.851.077.407h2.392l-.034-.41-.638-7.647-.834-.051-3.6-.214-.885-.054v2.283C661.646,767.627,656.374,770.329,656.641,771.578Z",
    transform: "translate(-542.861 -547.3)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_430",
    "data-name": "Path 430",
    d: "M503.526,614.391l-2.833,1.822-8.376-10.059,4.181-2.689Z",
    transform: "translate(-329.523 -403.904)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_431",
    "data-name": "Path 431",
    d: "M820.693,749.879a1.433,1.433,0,0,0,1.969.429l5.332-3.43-.055-.449-.247-2.042,1.293,1.369.285.3,2.011-1.294-.251-.326-4.674-6.086-.729.408-3.147,1.771-.774.433,1.235,1.92C822.765,743.847,819.792,748.972,820.693,749.879Z",
    transform: "translate(-652.551 -529.712)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_432",
    "data-name": "Path 432",
    d: "M674.407,790.448l-104.295.1a.394.394,0,0,1,0-.788l104.295-.1a.394.394,0,0,1,0,.787Z",
    transform: "translate(-484.692 -564.053)",
    fill: "#cacaca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_433",
    "data-name": "Path 433",
    d: "M700.26,452.085s-15.964,8.444-24.408,2.683c0,0-1.847,8.946-2.587,9.686s-1.919,1.063-1.083,1.888,1.3,1.941-.288,3.357-3.175.967-1.642,2.425-4.635,37.234-4.635,37.234.987,33.27,0,34.276-2.306,1.232-1.03,2.476,1.276.279,1.276,2v1.716l.584,1.706h8.011s1.933-2.246,0-4.2.588-2.484,1.178-4.315,1.576.143.59-1.83-1.461-1.6-1.471-2.9S689.3,486.166,689.3,486.166l1.763,28.131,21.207,30.809,6.242-4.682s-4.545-6.4-3.482-7.277-3.132-1.983-1.81-2.975-1.862-1.992-.661-3.307-1.654-4.63-3.307-4.63-3.974-5.526-3.974-5.526l3.464-43.652Z",
    transform: "translate(-547.833 -338.12)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_434",
    "data-name": "Path 434",
    d: "M704.885,267.695a4.921,4.921,0,0,1-2.1-.09c-2.14-.313-2.432.059-4.032,1.514-2.317,2.108-1,14.966-2.139,17.752l-.368.271a13.233,13.233,0,0,0,2.143-.6c.393-1.241.787-2.485,1.185-3.725a10.912,10.912,0,0,1,.7,3.008,16.807,16.807,0,0,1,3.4-1.461c1.159-.786,9.545-1.577,10.623-1.923C717.038,273.133,712.628,269.368,704.885,267.695Z",
    transform: "translate(-569.378 -214.583)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_87",
    "data-name": "Ellipse 87",
    cx: 8.014,
    cy: 8.014,
    r: 8.014,
    transform: "translate(130.324 51.44)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_435",
    "data-name": "Path 435",
    d: "M742.392,257.714a3.579,3.579,0,0,1-1.281-.449,1.218,1.218,0,0,1-.583-1.152,1.231,1.231,0,0,1,1.319-.875,3.589,3.589,0,0,1,1.59.644,2.465,2.465,0,0,0-2.1-2.209,5.116,5.116,0,0,1,2.249.215,1.75,1.75,0,0,1,1.16,1.764,2.874,2.874,0,0,1,2.829,1.755,4.78,4.78,0,0,1,0,3.483,1.23,1.23,0,0,1-.617.815,1.319,1.319,0,0,1-1.168-.351,27.93,27.93,0,0,1-4.871-4.5",
    transform: "translate(-599.008 -205.308)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_436",
    "data-name": "Path 436",
    d: "M720.549,274.6c-.34.16-.163.755-.427,1.021a1.085,1.085,0,0,1-.4.252,4.873,4.873,0,0,0-.343-1.446c-.035-.084-.091-.178-.18-.17s-.131.148-.133.249a4.181,4.181,0,0,1-.328,1.458l-.007.017-.23-.007c-.572-.022-1.841-1.493-2.122-.994a18.661,18.661,0,0,0,2.386-6.415,2.843,2.843,0,0,0-.091-1.258,1.112,1.112,0,0,0-.925-.765.708.708,0,0,0-.733.809l-.143-.02c-1.327-1.081-.183-2.958-1.727-3.7-.523-.252-3.726.59-4.291.442a4.861,4.861,0,0,0-.358-1.734c-.034-.084-.091-.178-.18-.17s-.131.148-.133.249a4.181,4.181,0,0,1-.328,1.458A6.112,6.112,0,0,0,707.5,264c-.676.178-1.318.484-2,.646a2.58,2.58,0,0,1-2.028-.222,2.285,2.285,0,0,1-.582-2.8,5.509,5.509,0,0,1,1.239-1.6c.387-.375.789-.735,1.192-1.1l1.081-.97a13.164,13.164,0,0,1,1.446-1.179,7.134,7.134,0,0,1,5.569-.972c1.135.271,2.652-.111,3.691.419a21.877,21.877,0,0,1,2.22,1.727c1.219.97.394.18,1.727.74C724.241,260.03,722.835,273.521,720.549,274.6Z",
    transform: "translate(-573.671 -206.624)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_395",
    "data-name": "Group 395"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_88",
    "data-name": "Ellipse 88",
    cx: 49.698,
    cy: 49.698,
    r: 49.698,
    transform: "translate(8.45 27.068)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_437",
    "data-name": "Path 437",
    d: "M386.867,288.225a50.194,50.194,0,1,1,50.194-50.194A50.251,50.251,0,0,1,386.867,288.225Zm0-99.4a49.2,49.2,0,1,0,49.2,49.2A49.258,49.258,0,0,0,386.867,188.829Z",
    transform: "translate(-328.719 -161.264)",
    fill: "#00b0ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_438",
    "data-name": "Path 438",
    d: "M429.32,313.126a5.527,5.527,0,0,1-4.422-2.212l-13.558-18.078a5.528,5.528,0,1,1,8.845-6.633l8.87,11.826,22.782-34.173a5.528,5.528,0,1,1,9.2,6.133L433.92,310.664a5.531,5.531,0,0,1-4.446,2.46Z",
    transform: "translate(-377.952 -210.494)",
    fill: "#00b0ff"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_89",
    "data-name": "Ellipse 89",
    cx: 1.739,
    cy: 2.499,
    rx: 1.739,
    ry: 2.499,
    transform: "matrix(0.144, -0.99, 0.99, 0.144, 104.154, 31.174)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_90",
    "data-name": "Ellipse 90",
    cx: 1.739,
    cy: 2.499,
    rx: 1.739,
    ry: 2.499,
    transform: "matrix(0.144, -0.99, 0.99, 0.144, 120.416, 29.588)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_91",
    "data-name": "Ellipse 91",
    cx: 1.739,
    cy: 2.499,
    rx: 1.739,
    ry: 2.499,
    transform: "matrix(0.144, -0.99, 0.99, 0.144, 99.701, 18.009)",
    fill: "#ff6584"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_92",
    "data-name": "Ellipse 92",
    cx: 1.579,
    cy: 1.099,
    rx: 1.579,
    ry: 1.099,
    transform: "matrix(0.008, -1, 1, 0.008, 95.622, 13.179)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_93",
    "data-name": "Ellipse 93",
    cx: 1.579,
    cy: 1.099,
    rx: 1.579,
    ry: 1.099,
    transform: "matrix(0.008, -1, 1, 0.008, 93.226, 3.134)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_94",
    "data-name": "Ellipse 94",
    cx: 1.579,
    cy: 1.099,
    rx: 1.579,
    ry: 1.099,
    transform: "matrix(0.008, -1, 1, 0.008, 111.86, 20.812)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_95",
    "data-name": "Ellipse 95",
    cx: 1.579,
    cy: 1.099,
    rx: 1.579,
    ry: 1.099,
    transform: "matrix(0.008, -1, 1, 0.008, 104.002, 24.735)",
    fill: "#ff6584"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_96",
    "data-name": "Ellipse 96",
    cx: 1.579,
    cy: 1.099,
    rx: 1.579,
    ry: 1.099,
    transform: "matrix(0.008, -1, 1, 0.008, 114.941, 31.987)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_97",
    "data-name": "Ellipse 97",
    cx: 1.739,
    cy: 2.499,
    rx: 1.739,
    ry: 2.499,
    transform: "matrix(0.144, -0.99, 0.99, 0.144, 10.892, 148.91)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_98",
    "data-name": "Ellipse 98",
    cx: 1.739,
    cy: 2.499,
    rx: 1.739,
    ry: 2.499,
    transform: "matrix(0.144, -0.99, 0.99, 0.144, 27.154, 147.324)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_99",
    "data-name": "Ellipse 99",
    cx: 1.739,
    cy: 2.499,
    rx: 1.739,
    ry: 2.499,
    transform: "matrix(0.144, -0.99, 0.99, 0.144, 6.439, 135.745)",
    fill: "#ff6584"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_100",
    "data-name": "Ellipse 100",
    cx: 1.579,
    cy: 1.099,
    rx: 1.579,
    ry: 1.099,
    transform: "matrix(0.008, -1, 1, 0.008, 2.359, 130.915)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_101",
    "data-name": "Ellipse 101",
    cx: 1.579,
    cy: 1.099,
    rx: 1.579,
    ry: 1.099,
    transform: "matrix(0.008, -1, 1, 0.008, -0.037, 120.87)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_102",
    "data-name": "Ellipse 102",
    cx: 1.579,
    cy: 1.099,
    rx: 1.579,
    ry: 1.099,
    transform: "matrix(0.008, -1, 1, 0.008, 18.597, 138.547)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_103",
    "data-name": "Ellipse 103",
    cx: 1.579,
    cy: 1.099,
    rx: 1.579,
    ry: 1.099,
    transform: "matrix(0.008, -1, 1, 0.008, 10.739, 142.471)",
    fill: "#ff6584"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_104",
    "data-name": "Ellipse 104",
    cx: 1.579,
    cy: 1.099,
    rx: 1.579,
    ry: 1.099,
    transform: "matrix(0.008, -1, 1, 0.008, 21.678, 149.723)",
    fill: "#3f3d56"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowItWorksImage3);
export default __webpack_public_path__ + "static/media/how-it-works-image-3.bd9631231f03c92f52eb43cdb9684c81.svg";
export { ForwardRef as ReactComponent };